import { RescuePlanModel } from '../../../api';
import RescuePlanPageTwo from "./RescuePlanPageTwo";
import RescuePlanPageOne from "./RescuePlanPageOne";
import React from "react";
import "./RescuePlanPageOne.css"

interface RescuePlanProps {
    rescuePlan: RescuePlanModel;
    setRescuePlan?: React.Dispatch<React.SetStateAction<RescuePlanModel | undefined>>;
}

const RescuePlan: React.FC<RescuePlanProps> = (props) => {

    const handleChangePageOne = (updatedData: any) => {
        props.setRescuePlan?.((prevState: RescuePlanModel | undefined) => {
            if (!prevState) return undefined;
            return {
                ...prevState,
                pageOne: { ...prevState.pageOne, ...updatedData }
            };
        });
    };

    const handleChangePageTwo = (updatedData: any) => {
        props.setRescuePlan?.((prevState: RescuePlanModel | undefined) => {
            if (!prevState) return undefined;
            return {
                ...prevState,
                pageTwo: { ...prevState.pageTwo, ...updatedData }
            };
        });
    };

    return (
        <div style={{ pageBreakInside: "avoid" }}>
            <RescuePlanPageOne rescuePlanPageOne={(props.rescuePlan?.pageOne ?? {}) as any} onUpdate={handleChangePageOne} />
            <RescuePlanPageTwo rescuePlanPageTwo={(props.rescuePlan?.pageTwo ?? {}) as any} onUpdate={handleChangePageTwo} />
        </div>
    )
}

export default RescuePlan;